import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('../views/indexPage/index.vue')
  },
  {
    path: "/productSSP",
    name: "productSSP",
    component: () => import('../views/productSSP/index.vue')
  },
  {
    path: "/productADX",
    name: "productADX",
    component: () => import('../views/indexPage/index.vue')
    // component: productView,
  },
  {
    path: "/productPrecise",
    name: "productPrecise",
    component: () => import('../views/productPrecise/index.vue')
    // component: productView,
  },
  {
    path: "/productPromotion",
    name: "productPromotion",
    component: () => import('../views/productPromotion/index.vue')
    // component: productView,
  },
  // {
  //   path: "/Solution",
  //   name: "product",
  //   component: () => import('../views/indexPage/index.vue')
  //   // component: productView,
  // },
  {
    path: "/docs",
    beforeEnter() {
      // 开发环境重定向到 VuePress 开发服务器
      if (process.env.NODE_ENV === "development") {
        window.location.href = "http://localhost:8081/docs/index";
      } else {
        window.location.href = "/docs/"; // 生产环境重定向到打包后的文件
      }
    },
  },
  // {
  //   path: "/AboutUs",
  //   name: "AboutUs",
  //   component: () => import('../views/indexPage/index.vue')
  //   // component: productView,
  // },
  {
    path: "/PrivacyPolicy",
    name: "PrivacyPolicy",
    component: () => import('../views/PrivacyPolicy/index.vue')
    // component: productView,
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;  // 如果有滚动位置，恢复滚动
    } else {
      return { x: 0, y: 0 };  // 否则，滚动到顶部
    }
  }
});

export default router;
